// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"4af0fb89","894":"98b37db2"}[chunkId] + ".chunk.js";
};